import { render, staticRenderFns } from "./all-preferences.vue?vue&type=template&id=47567268&"
import script from "./all-preferences.vue?vue&type=script&lang=js&"
export * from "./all-preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports